<div class="options" *ngIf="_appService.user_data?.length != 0">
  <a class="option" routerLink="/affiliate/main" routerLinkActive="active-link">
    <div class="button">
      <span class="button__label">{{ 'NAV.MENU.CAMPAIGNS' | translate }}</span>
      <!-- <span class="icon icon-bullhorn button__icon"></span> -->
      <div class="border-bottom"></div>
    </div>
  </a>

  <!-- <a class="option" routerLink="/affiliate/config" routerLinkActive="active-link">
    <div class="button">
      <span class="button__lable">Configurar</span>
       <span class="icon icon-settings-fill button__icon"></span> 
      <div class="border-bottom"></div>
    </div>
  </a>  -->

  <a class="option" routerLink="/affiliate/metrics" routerLinkActive="active-link">
    <div class="button">
      <span class="button__label">{{ 'NAV.MENU.METRICS' | translate }}</span>
      <span class="icon icon-stats-dots button__icon"></span>
      <div class="border-bottom"></div>
    </div>
  </a>
  
  <a class="option" routerLink="/affiliate/referrals" routerLinkActive="active-link">
    <div class="button">
      <span class="button__label">{{ 'NAV.MENU.REFERRALS' | translate }}</span>
      <span class="icon icon-person-group button__icon"></span>
      <div class="border-bottom"></div>
    </div>
  </a>

  <a class="option" routerLink="/affiliate/resources" routerLinkActive="active-link">
    <div class="button">
      <span class="button__label">{{ 'NAV.MENU.RESOURCES' | translate }}</span>
      <span class="icon icon-stats-dots button__icon"></span>
      <div class="border-bottom"></div>
    </div>
  </a>

</div>